import { render, staticRenderFns } from "./Drafts.vue?vue&type=template&id=dd5e614c&scoped=true"
import script from "./Drafts.vue?vue&type=script&lang=js"
export * from "./Drafts.vue?vue&type=script&lang=js"
import style0 from "./Drafts.vue?vue&type=style&index=0&id=dd5e614c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5e614c",
  null
  
)

export default component.exports